import { UserProfile } from '../types';
import { create } from 'zustand';
import { fetchData } from '../axios/fetchData';
import { ShowMessageCalBack } from '../components';
import { NavigateFunction } from 'react-router';

type UserState = {
  user: UserProfile;
};

type UserActions = {
  getUserProfile: (userId: string, showMessage: ShowMessageCalBack, navigate: NavigateFunction) => void;
};

export const useUserStore = create<UserState & UserActions>()((set) => ({
  user: null,
  getUserProfile: async (userId, showMessage, navigate) => {
    const result = await fetchData(
      {
        url: import.meta.env.VITE_APP_USER + userId,
        params: {
          _format: 'json', // Added format=json to the request
        },
      },
      showMessage,
      navigate
    );
    return set({
      user: (result.data as UserProfile) || null,
    });
  },
}));
